import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MatPaginator, MatSelect, MatTableDataSource } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { EducationPackageService } from 'src/app/services/http/business/educationPackage/education-package.service';
import { LevelInfoService } from 'src/app/services/http/business/levelInfo/level-info.service';
//import { BIDService } from 'src/app/services/common/bid.service';
//import { CIDService } from 'src/app/services/common/cid.service';
import { BranchService } from 'src/app/services/http/business/branch/branch.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { IBranch } from 'src/app/interfaces/branch';
import { ICompany } from 'src/app/interfaces/company';
import { ILevelInfo } from 'src/app/interfaces/levelInfo';
import { IEducationPackage } from 'src/app/interfaces/educationPackage';
import { TermInfoService } from 'src/app/services/http/business/term-info/term-info.service';
import { ITermInfoByCourseType } from 'src/app/interfaces/termInfoByCourseType';
import { CourseTypeService } from 'src/app/services/http/business/course-type/course-type.service';
//import { StaticValueService } from 'src/app/services/http/business/staticValue/static-value.service';
import { CalendarService } from 'src/app/services/http/business/calendar/calendar.service';
//import { HoldingService } from 'src/app/services/http/business/holding/holding.service';
import { HttpHeaders } from '@angular/common/http';
import { CourseService } from 'src/app/services/http/business/course/course.service';
import { ParrentTermService } from 'src/app/services/http/business/parrent-term/parrent-term-service.service';
import { IParentTerm } from 'src/app/interfaces/parent-term';
import { StaticValueService } from 'src/app/services/http/business/staticValue/static-value.service';


@Component({
  selector: 'app-quick-search-courses',
  templateUrl: './quick-search-courses.component.html',
  styleUrls: ['./quick-search-courses.component.css']
})
export class QuickSearchCoursesComponent implements OnInit {
  param: any;
  personInfo: any;
  errObject: any;
  isOwner: boolean;
  form: FormGroup;
  errors = new Array();
  isUpdate: boolean;
  eduPackageList: IEducationPackage;
  levelInfoList: ILevelInfo;
  companyList: ICompany[];
  branchList: IBranch[];
  coursePatternList = [];
  courseTypeList: any;
  courseStatusList: any[];
  termInfoList: any[];
  parrentTermList: IParentTerm[];
  yearList = [];
  filter: any;
  dataSource = new MatTableDataSource();

  displayedColumns: string[] = [
    this.translate.get("label.level"),
    "branch",
    this.translate.get("label.teacherName"),
    "date",
    this.translate.get("label.pattern"),
    this.translate.get("label.discount"),
    this.translate.get("label.isRegisterd"),
    this.translate.get("label.room"),
    this.translate.get("label.status")
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private eduPackageService: EducationPackageService,
    private calendatService: CalendarService,
    private levelInfoService: LevelInfoService,
    private staticValueService: StaticValueService,
    //private bidService: BIDService,
    private parrentTermService: ParrentTermService,
    //private cidService: CIDService,
    private branchService: BranchService,
    private courseService: CourseService,
    private termInfoService: TermInfoService,
    private companyService: CompanyService,
    //private staticValueService: StaticValueService,
    public dialogRef: MatDialogRef<QuickSearchCoursesComponent>,
    private courseTypeService: CourseTypeService,
    //private holdingService: HoldingService

  ) { }

  ngOnInit() {
    // this.checkOwner();
    this.createForm();
    this.getEduPackage();
    this.getCompanyList();
    this.getCourseStatus(true);

    this.getYear();
  }

  createForm() {
    this.form = this.fb.group({
      CompanyEncryptId: [null],
      BranchEncryptId: [null],
      PackageId: [null],
      LevelInfoId: [null],
      TermInfoId: [null],
      TermNumber: [null],
      CoursePatternId: [null],
      ParentTermId: [null],
      CourseStatusId: [null],
      CourseTypeId: [null],
      Year: [null]
    });
  }
  // checkOwner() {
  //   this.holdingService.checkOwnerHolding().subscribe(res => {
  //     this.isOwner = res.IsOwner;
  //     if (res.IsOwner)
  //       this.getCompanyList();

  //   });
  // }
  getEduPackage() {
    this.eduPackageService.getList().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      err => {
        console.log(err);
      }
    );
  }
  getLevelInfo(e: MatSelect) {
    this.levelInfoService.getList(e.value).subscribe(
      res => {
        this.levelInfoList = res.DataList;
      },
      err => {
        console.log(err);
      }
    );
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  getBranchList(company) {

    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );

    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(res => {
      this.branchList = res.DataList;
    });
  }

  getCourseType(company) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );

    this.courseTypeService.listWithCompany(0, 0, true, false, false, headers).subscribe(res => {
      this.courseTypeList = res.DataList;
    });
  }

  setValueCourseTypeToChildren(e: MatSelect) {
    this.coursePatternList = this.courseTypeList.filter(function(item){
      return item.Id == e.value
    })[0].CoursePatternList
  }

  getYear() {
    this.calendatService.yearList().subscribe(res => {

      res.forEach(item => {
        if (item.Selected) {
          this.form.controls['Year'].setValue(item.Value);
        }
      });
      this.yearList = res;
    });
  }

  getTermInfo(obj: any, page: number, pageSize: number) {

    this.errors = new Array();
    var data: ITermInfoByCourseType = {
      CourseTypeId: obj.Id,
      Year: this.form.controls['Year'].value,
      xPage: page,
      xPageSize: pageSize,
      xOrderBy: "",
      xOrderDesc: false
    };
    this.termInfoService.ListByCourseTypeId(data).subscribe(
      res => {

        this.termInfoList = res.DataList;
      },
      err => {
        this.errObject = this.errorService.getError(err);
        this.param = this.errorService.objectError(this.errObject);
        this.errors = this.errorService.returnError(err);
      }
    );
  }
  getCourseStatus(time: boolean) {
    this.staticValueService.courseStatus(time).subscribe(
      res => {

        this.courseStatusList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  setCid(e: MatSelect) {
    this.getBranchList(e.value);
    this.getCourseType(e.value);
    this.getParrentTermList(e.value);
  }

  // setBid(e: MatSelect) {
  //   this.bidService.setBID(e.value);
  // }
  submit(data: any) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        this.form.get('CompanyEncryptId').value
      )
      .append(
        "BID",
        data.BranchEncryptId ? data.BranchEncryptId : null
      );
    this.filter = data;
    this.courseService.listByCompany(data, 1, 10, headers).subscribe(res => {
      this.dataSource = null;
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    });
  }

  getParrentTermList(company) {

    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );

    this.parrentTermService.listByCompanyHeader(0, 0, headers).subscribe(
      res => {
        this.parrentTermList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  paginatorEvent(event) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        this.form.get('CompanyEncryptId').value
      )
      .append(
        "BID",
        this.form.get('BranchEncryptId').value
      );
    this.courseService.listByCompany(this.filter, event.pageIndex + 1, event.pageSize, headers)
      .subscribe(res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
